import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import App from './App';
import { RequestMocks } from './mocks';
import reportWebVitals from './reportWebVitals';

window.requestMocks = new RequestMocks();

const container = document.getElementById('root');

if (!container) {
  throw new Error('Could not find root element');
}

const root = createRoot(container);

root.render(
  <StrictMode>
    <App />
  </StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
